import LegalLayout from "@/components/legal/LegalLayout";

const H2 = ({ children }) => (
  <h2 className="font-display text-3xl md:text-4xl tighter text-white mt-14 mb-5 leading-tight">
    {children}
  </h2>
);
const H3 = ({ children }) => (
  <h3 className="font-body font-semibold text-lg md:text-xl text-white/90 mt-8 mb-3">
    {children}
  </h3>
);
const P = ({ children }) => <p>{children}</p>;
const UL = ({ children }) => (
  <ul className="list-disc pl-6 space-y-2 marker:text-[#FF6B1A]">{children}</ul>
);
const PH = ({ children }) => (
  <span className="font-mono text-[13px] tracking-[0.06em] uppercase text-[#FF6B1A]/90 bg-[#FF6B1A]/10 border border-[#FF6B1A]/25 rounded px-2 py-[3px]">
    {children}
  </span>
);

export default function PrivacyPolicy() {
  return (
    <LegalLayout eyebrow="Informativa — GDPR" title="Privacy Policy" updated="Gennaio 2026">
      <P>
        La presente informativa descrive le modalità di trattamento dei dati personali degli utenti che consultano il sito
        Modo Motori (di seguito, "il Sito") e utilizzano il modulo di contatto commerciale, ai sensi del Regolamento (UE)
        2016/679 (GDPR) e della normativa italiana vigente in materia di protezione dei dati personali.
      </P>

      <H2>1. Titolare del trattamento</H2>
      <P>
        Il Titolare del trattamento è <strong className="text-white">Delta Pictures S.r.l.</strong>, con sede legale in{" "}
        <strong className="text-white">Via G. Boglietti 2, 13900 Biella</strong>, P.IVA{" "}
        <strong className="text-white">02154000026</strong>, Cap. Soc. € 50.000 i.v. Per ogni richiesta relativa al trattamento dei dati è possibile scrivere a{" "}
        <a href="mailto:privacy@modomotori.it" className="text-[#FF6B1A] hover:underline">privacy@modomotori.it</a>.
      </P>

      <H2>2. Tipologie di dati trattati</H2>
      <P>Attraverso il Sito, in particolare tramite il modulo di contatto, possono essere trattate le seguenti categorie di dati:</P>
      <UL>
        <li>Dati identificativi: nome, cognome, ruolo aziendale.</li>
        <li>Dati aziendali: ragione sociale dell'azienda di appartenenza.</li>
        <li>Dati di contatto: indirizzo e-mail, numero di telefono (facoltativo).</li>
        <li>Contenuto della richiesta: tipologia di progetto e testo del messaggio.</li>
        <li>Dati tecnici di navigazione: indirizzo IP, tipo di browser, sistema operativo, pagine visitate (dati raccolti automaticamente dai server).</li>
      </UL>

      <H2>3. Finalità e base giuridica del trattamento</H2>
      <P>I dati raccolti sono trattati esclusivamente per le seguenti finalità:</P>
      <UL>
        <li>
          <strong className="text-white">Riscontro alle richieste commerciali</strong> inviate tramite il modulo di contatto —
          base giuridica: esecuzione di misure precontrattuali su richiesta dell'interessato (art. 6.1 lett. b GDPR).
        </li>
        <li>
          <strong className="text-white">Adempimenti di legge</strong> in materia contabile, fiscale e amministrativa —
          base giuridica: obbligo legale (art. 6.1 lett. c GDPR).
        </li>
        <li>
          <strong className="text-white">Sicurezza del Sito</strong> e prevenzione di abusi — base giuridica: legittimo interesse
          del Titolare (art. 6.1 lett. f GDPR).
        </li>
      </UL>
      <P>
        Il conferimento dei dati contrassegnati come obbligatori nel modulo di contatto è necessario per poter dare seguito alla
        richiesta. Il mancato conferimento rende impossibile la risposta.
      </P>

      <H2>4. Modalità del trattamento</H2>
      <P>
        Il trattamento avviene con strumenti informatici e telematici, con misure di sicurezza tecniche e organizzative adeguate
        a garantire riservatezza, integrità e disponibilità dei dati. I dati vengono elaborati esclusivamente da personale
        autorizzato del Titolare o da fornitori esterni nominati Responsabili del trattamento (es. servizio di invio e-mail
        transazionali e provider di hosting).
      </P>

      <H2>5. Comunicazione dei dati e destinatari</H2>
      <P>I dati possono essere comunicati, per le finalità sopra indicate, ai seguenti soggetti:</P>
      <UL>
        <li>Personale autorizzato del Titolare (redazione, ufficio commerciale, amministrazione).</li>
        <li>Fornitori di servizi tecnologici (hosting, invio e-mail transazionali, analytics).</li>
        <li>Consulenti professionali (studi legali, commercialisti) e autorità pubbliche, ove richiesto per obblighi di legge.</li>
      </UL>
      <P>
        I dati non sono oggetto di diffusione né di trasferimento verso Paesi terzi extra-UE, salvo l'utilizzo di servizi cloud
        che garantiscono adeguate misure di protezione (Standard Contractual Clauses UE).
      </P>

      <H2>6. Periodo di conservazione</H2>
      <UL>
        <li>Dati del modulo di contatto: conservati per il tempo necessario a gestire la richiesta e, successivamente, per un massimo di 24 mesi per finalità di documentazione delle attività commerciali.</li>
        <li>Dati di navigazione: conservati per il tempo strettamente necessario alle finalità di sicurezza (di norma non oltre 12 mesi).</li>
        <li>Dati necessari ad adempimenti fiscali e contabili: conservati per il periodo previsto dalla legge (10 anni).</li>
      </UL>

      <H2>7. Diritti dell'interessato</H2>
      <P>L'interessato può esercitare in qualsiasi momento i diritti previsti dagli articoli 15-22 del GDPR:</P>
      <UL>
        <li>Accesso ai propri dati personali.</li>
        <li>Rettifica dei dati inesatti o integrazione di quelli incompleti.</li>
        <li>Cancellazione dei dati ("diritto all'oblio"), nei casi previsti dalla normativa.</li>
        <li>Limitazione del trattamento.</li>
        <li>Portabilità dei dati.</li>
        <li>Opposizione al trattamento fondato sul legittimo interesse.</li>
        <li>Revoca del consenso in qualsiasi momento, senza pregiudicare la liceità del trattamento precedente.</li>
      </UL>
      <P>
        Le richieste vanno inviate a{" "}
        <a href="mailto:privacy@modomotori.it" className="text-[#FF6B1A] hover:underline">privacy@modomotori.it</a>. L'interessato
        ha inoltre diritto di proporre reclamo al{" "}
        <a href="https://www.garanteprivacy.it" target="_blank" rel="noreferrer noopener" className="text-[#FF6B1A] hover:underline">
          Garante per la protezione dei dati personali
        </a>{" "}
        (www.garanteprivacy.it).
      </P>

      <H2>8. Modifiche alla presente informativa</H2>
      <P>
        La presente informativa può essere modificata o aggiornata anche a seguito di variazioni normative. La versione in
        vigore è sempre quella pubblicata su questa pagina, con indicazione della data di ultimo aggiornamento.
      </P>
    </LegalLayout>
  );
}
